import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import CreateJobStepper from "./CreateJobStepper";

import UnlockPremiumFeatureFigure from "../assets/images/unlock-premium-features.png";
import { ListItemIcon } from "../assets/icons/go-hire-page-icons";

const JobBoostStepLooked = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.jobBoost" });

  const features = [
    t("reachWiderRelevantAudience"),
    t("getJobSeenByRightPeople"),
    t("saveTimeAndBoostVisibility"),
    t("stayInControlOfMarketingSpend"),
  ];

  return (
    <Box sx={styles.container}>
      <Box sx={styles.stepContainer}>
        <CreateJobStepper currentStep="job-boost" />
        <Box sx={styles.content} component="main">
          <Typography sx={styles.title}>{t("jobBoost")}</Typography>
          <Box sx={styles.previewContainer}>
            <Box
              component="img"
              src={UnlockPremiumFeatureFigure}
              alt="Unlock Premium Features"
              sx={styles.previewImage}
            />
            <Box sx={styles.previewContent}>
              <Typography sx={styles.previewTitle}>{t("jobBoostLocked")}</Typography>
              <Typography sx={styles.previewDescription}>{t("jobBoostDescription")}</Typography>
            </Box>
            <Box sx={styles.previewFeatures}>
              <Typography sx={styles.previewFeatureTitle}>{t("whySubscribe")}</Typography>
              <Box sx={styles.previewFeatureList}>
                {features.map((feature, index) => (
                  <Box sx={styles.previewFeatureItem} key={index}>
                    <ListItemIcon />
                    <Typography sx={styles.previewFeatureItemTitle}>{feature}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default JobBoostStepLooked;

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  stepContainer: {
    display: "flex",
    gap: "24px",
    maxWidth: "1140px",
    width: "80%",
    margin: "0 auto",
    flex: 1,
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "20px 24px",
  },
  title: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  previewContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    borderRadius: "12px",
    border: "1px solid var(--Gray-200, #EAECF0)",
    background:
      "linear-gradient(180deg, rgba(157, 0, 236, 0.08) 0%, rgba(157, 0, 236, 0.01) 30.21%, rgba(157, 0, 236, 0.01) 100%), #FFF",
    padding: "24px 70px",
    width: "782px",
  },
  previewImage: {
    width: "122px",
    height: "114px",
  },
  previewContent: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: "8px",
  },
  previewTitle: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "30px",
  },
  previewDescription: {
    color: "var(--Gray-600, #475467)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
  previewFeatures: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  previewFeatureTitle: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  previewFeatureList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  previewFeatureItem: {
    display: "flex",
    gap: "12px",
  },
  previewFeatureItemTitle: {
    color: "var(--Gray-600, #475467)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
  subscribeButton: {
    padding: "10px 32px",
    borderRadius: "999px",
    border: "1px solid #D0D5DD",
    background: "linear-gradient(269deg, #9D00EC 0.55%, #1F3693 98.76%), #FFF",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    color: "var(--White, #FFF) !important",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
};
